// extracted by mini-css-extract-plugin
export default {"header":"styles_header__90op0","pagination":"styles_pagination__ANyfx"};